import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrphanedAssignmentsClientGroupedItem from '../../../../Domain/OrphanedAssignmentsClientGroupedItem';
import OrphanedAssignmentService from '../../../../Services/OrphanedAssignmentService';

export default class OrphanedAssignmentsClientGroupedAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={OrphanedAssignmentsClientGroupedItem}
          serviceFunction={OrphanedAssignmentService.GetOrphanedAssignmentsClientGrouped}
          convertDBItemsFunction={OrphanedAssignmentService.ConvertOrphanedAssignmentsClientGroupedDBItems}
          searchItem={{}}
          orderBy='AsSassieSurveyId'
          errorCode='OACGA24'
        />
      </div>
    );
  }
}
